import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEditSmall1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"edit-small-1, box, pencil, pen, write, draw"} maskId="square-filled-radius-0-stroke-1-IconEditSmall1"><path d="M11 7.87891V13H16.1211L21 8.12109V21H3V3H15.8789L11 7.87891Z" fill="currentColor"/><path d="M22.207 5.5L15.707 12H12V8.29297L18.5 1.79297L22.207 5.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEditSmall1;
